<template>
    <tr>
        <td :colspan="columns.length" class="table-divider">
            <div class="flex flex-column">
                <span class="font-heading font-semi-bold text-sm">{{ group.title }}</span>
                <span v-if="group.description" class="text-xs text-gray-400">{{ group.description }}</span>
            </div>
        </td>
    </tr>
</template>

<script>
export default {
        name: 'TableGroupRow',

        props: {
            // The columns (headers) of the table
            columns: {
                type: Array,
                required: true
            },

            // The group to display on the row
            group: {
                type: Object,
                required: true
            }
        },

    }
</script>